import _ from 'lodash';
import { useRef, useState } from 'react';

export default ({ defaultModel = {} }) => {
	// Declare a model, get, and set for it
  	const [model, setStateModel] = useState(_.cloneDeep(defaultModel));
	const [invalid, setInvalidModel] = useState({});
	const origModel = useRef(_.cloneDeep(defaultModel));
  	const get = name => model[name];
	const getInvalid = name => invalid[name];
	const getModel = () => _.cloneDeep(model);
	const getOrigModel = () => _.cloneDeep(origModel.current);
  	const set = (name, value) => {
	    // Set in model synchronously
	    model[name] = value;
		// Set in model for side effects
	    setStateModel(origValue => ({ ...origValue, [name]: value }));
		return value;
  	};
	const setInvalid = (name, value) => {
	    // Set in model synchronously
	    invalid[name] = value;
		// Set in model for side effects
	    setInvalidModel(origValue => ({ ...origValue, [name]: value }));
	};
	const setModel = newModel => {
		origModel.current = _.cloneDeep(newModel);
		// Set in model synchronously
		Object.keys(model).forEach(key => delete model[key]);
		Object.assign(model, newModel);
		setStateModel(_.cloneDeep(newModel));
	};
	return { get, getInvalid, getModel, getOrigModel, set, setInvalid, setModel };
};
